export { default as compressAndBase62Encode } from './compressAndBase62Encode';